<template>
    <div class="reader">
      <transition name="slider-top">
        <div v-show="visible" class="header">
          <div @click="$router.go(-1)" class="left">
            <i class="back"></i>
            <p class="chapter-name">{{title}}</p>
          </div>
          <i class="detail-icon" @click="$emit('operate', 'detail')"></i>
        </div>
      </transition>
      <!-- 漫画 -->
      <div ref="target" class="display-box" @click="readClick" @scroll="onScroll" @touchmove="readerTouchmove">
        <img v-for="(item, i) in content" :key="item" :src="item" alt="" class="img-item" @load="onload(i)">
        <div class="observe-el"></div>
      </div>
      <!-- 操作台 -->
      <transition name="slider-bottom">
      <div v-show="visible" class="console">
        <i @click="$emit('operate', 'last')" class="last-chapter"></i>
        <i @click="$emit('operate', 'next')" class="next-chapter"></i>
        <Slider v-model="value" @change="onChange"/>
        <div class="operation-wrap">
          <div class="operation" @click="$emit('operate', 'chapter')">
            <img src="@/assets/images/icon/menu.png" alt="" class="icon">
            Chapters
          </div>
          <div class="operation" @click="$emit('operate', 'favorite')">
            <img
              v-if="isFavorite"
              src="@/assets/images/icon/favorite-on.png"
              alt=""
              class="icon"
            >
            <img v-else src="@/assets/images/icon/favorite-white-off.png" alt="" class="icon">
            Favorite
          </div>
          <div class="operation" @click="$emit('operate', 'setting')">
            <img src="@/assets/images/icon/setting.png" alt="" class="icon">
            Setting
          </div>
        </div>
      </div>
    </transition>
    </div>
</template>

<script>
import animation from '@/utils/animation';
import { debounce } from '@/utils';
import Slider from './Slider.vue';

export default {
  components: { Slider },
  props: {
    title: String,
    content: Array,
    isFavorite: Boolean,
  },
  data() {
    return {
      value: 0,
      visible: true,
    };
  },
  watch: {
    content() {
      this.isEmit = false;
    },
    value(val, oldVal) {
      if (Math.ceil(val) === 100 && val > oldVal) { // 向上滑不触发
        this.emitEnd();
      }
    },
  },
  created() {
    this.emitEnd = debounce(this.emitEnd, 5000);
  },
  mounted() {
    const el = document.querySelector('.observe-el');
    if (el) {
      const ob = new IntersectionObserver(this.intersectionCallback);
      ob.observe(el);
    }
  },
  methods: {
    readClick(e) {
      const el = this.$refs.target || {};
      const screenH = (document.documentElement || document.body || {}).clientHeight || 0;
      const percent = Math.max(0, (Math.min((e.y / screenH) * 100, 100)));
      const event = this.getEvent(percent);
      switch (event) {
        case 'back':
          animation(el.scrollTop, Math.max(0, el.scrollTop - screenH), 300, (val) => {
            el.scrollTop = val;
          });
          this.visible = false;
          break;
        case 'visible':
          this.visible = !this.visible;
          break;
        case 'forward':
          animation(el.scrollTop, Math.min(this.distance, el.scrollTop + screenH), 300, (val) => {
            el.scrollTop = val;
          });
          this.visible = false;
          break;
        default:
          break;
      }
    },
    intersectionCallback(entries) { // watch value 和 intersection 都触发。做了防抖
      const entry = entries[0];
      if (!entry) return;
      // isEmit 前三张图片加载完毕
      if (!(this.isEmit && entry.isIntersecting)) return; // 隐藏不执
      this.emitEnd();
    },
    onload(i) { // 图片加载完成
      this.count = this.count || 0;
      const targetNum = Math.min(this.content.length, 3);
      if (i < targetNum) this.count += 1;
      if (this.count >= targetNum && !this.isEmit) {
        this.$emit('loaded');
        this.isEmit = true;
      }
      const el = this.$refs.target || {};
      const { clientHeight = 0, scrollHeight = 0 } = el;
      this.distance = scrollHeight - clientHeight; // 更新容器可滚动最大高度
    },
    onChange() { // slider change
      const el = this.$refs.target || {};
      const result = (this.value * this.distance) / 100;
      el.scrollTop = result;
    },
    readerTouchmove() {
      this.visible = false;
    },
    onScroll() { // 通过设置scrollTop也会触发scroll事件
      const el = this.$refs.target || {};
      this.value = (el.scrollTop / this.distance) * 100;
    },
    scrollToTop() {
      const el = this.$refs.target || {};
      this.value = 0;
      el.scrollTop = 0;
    },
    getEvent(percent) {
      const positionMap = [
        { range: [0, 40], event: 'back' },
        { range: [40, 60], event: 'visible' },
        { range: [60, 100], event: 'forward' },
      ];
      const match = positionMap.find(({ range }) => percent >= range[0] && percent < range[1]);
      return match ? match.event : 'top';
    },
    emitEnd() {
      this.$emit('operate', 'end');
    },

  },

};
</script>

<style lang="less" scoped>
.reader {
  height: 100%;
  position: relative;
  .display-box {
    height: 100%;
    overflow-y: scroll;
    .img-item {
        width: 100%;
        vertical-align: middle;
    }
  }
  .header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 56px;
    background-color: rgba(32, 37, 36, 1);
    display: flex;
    padding: 0 16px;
    align-items: center;
    justify-content: space-between;
    z-index: 100;
    .left {
      display: flex;
      align-items: center;
      .back {
        margin-right: 6px;
        .iconMixin({
          background-image: url(@/assets/images/icon/back-white.png);
        })
      }
      .chapter-name {
        color: rgb(243, 243, 243);
        font-size: @fontLarge;
        line-height: 36px;
        font-weight: 700;
      }
    }
    .detail-icon {
      .iconMixin({
        background-image: url(@/assets/images/icon/detail.png);
      })
    }
  }
  .console {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 136px;
    padding: 20px 0 0;
    background-color: rgba(32, 37, 36, 1);
    z-index: 100;
    .last-chapter {
      position: absolute;
      top: 20px;
      left: 16px;
      .iconMixin({
        background-image: url(@/assets/images/icon/back-white.png);
      })
    }
    .next-chapter {
      position: absolute;
      top: 20px;
      right: 16px;
      .iconMixin({
        background-image: url(@/assets/images/icon/back-white.png);
      });
      transform: rotateZ(180deg);
    }

  }
  .operation-wrap {
    padding-top: 8px;
    height: 88px;
    display: flex;
    .operation {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: rgba(255, 255, 255, 1);
      font-size: @fontMedium;
      .icon {
        width: 24px;
        height: 24px;
        margin-bottom: 4px;
      }
    }
  }
  .observe-el {
    height: 2px;
  }
}
</style>
